module.exports = __webpack_public_path__ + "img/img_mall_integral.c51ab90e.png";